module.exports = __webpack_public_path__ + "static/pocket-grimoire-1083658aaedc92ee4577d66cd2d826a6.png";